<template>
  <div class="columns is-vcentered">
    <div class="column is-3">
      <button
        id="submitForm"
        type="submit"
        class="button is-success is-large is-fullwidth"
        @click.stop.prevent="submit"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import bugsnagClient from '@/lib/bugsnag';

export default {
  props: {
    winner_type: {
      type: String,
      required: true,
    },
  },
  computed: {
    state() {
      return this.$store.state[this.$route.params.slug];
    },
  },
  methods: {
    async submit() {
      if (await this.veeValidateCheck() === false) {
        return false;
      }

      /* Default validity check */
      if (!document.getElementById(this.winner_type).reportValidity()) {
        return false;
      }

      // Uncomment when we're ready to actually POST to the server
      // this.postForm();

      return this.$router.push(`/${this.$route.params.slug}`);
    },
    buildQuery() {
      const sheet = `sheet=${this.state.google_sheet_title || ''}`;
      const secret = `secret=${this.$route.params.secret || ''}`;
      const project_type = `project_type=${this.state.project_type}`;
      const winner_type = `winner_type=${this.winner_type}`;
      const project = `project_id=${this.state.project_id}`;

      return `${sheet}&${secret}&${project}&${project_type}&${winner_type}`;
    },
    buildForm() {
      return new FormData(document.getElementById(this.winner_type));
    },
    submissionReport() {
      let submissionData = '';

      // eslint-disable-next-line no-restricted-syntax
      for (const pair of this.buildForm().entries()) {
        submissionData = `${submissionData + pair[0]}: ${pair[1]}, `;
      }
      bugsnagClient.metaData = { submission: submissionData };
    },
    async veeValidateCheck() {
      const valid = await this.$parent.validate();
      if (!valid) {
        setTimeout(() => {
          const errors = Object.entries(this.$parent.errors)
            .map(([key, value]) => ({ key, value }))
            .filter(error => error.value.length);
          if (errors.length > 0) {
            this.$parent.refs[errors[0].key].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }, 100);
        return false;
      }
      return true;
    },
    postForm() {
      window.fetch(`https://dj5-api.datajoe.com/api/survey?${this.buildQuery()}`, {
        body: this.buildForm(),
        method: 'post',
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }).then((res) => {
        if (!res.ok) {
          this.submissionReport();
          bugsnagClient.notify(res.statusText);
        }
      }).catch((error) => {
        this.submissionReport();
        bugsnagClient.notify(error);
      });
    },
  },
};
</script>
